import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { LoaderButton } from 'ctia-ui';
import { getPrerenderValues } from 'components/ModalConfirm/types';

const ModalConfirm = ({
  show,
  onHide,
  onHandle,
  onValidate,
  requestData,
  isLoading,
  type,
  isFormValid
}) => {
  if (!show) return null;

  const preRender = getPrerenderValues(type, requestData);

  if (!preRender) return null;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{preRender.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{preRender.body(isFormValid, onValidate)}</Modal.Body>
      <Modal.Footer>
        <LoaderButton
          bsStyle={preRender.button}
          text={preRender.buttonText}
          onClick={onHandle}
          isLoading={isLoading}
          loadingText={preRender.buttonLoadingText}
          style={{ marginRight: 15 }}
        />
        <LoaderButton text="Close" onClick={onHide} disabled={isLoading} />
      </Modal.Footer>
    </Modal>
  );
};

ModalConfirm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onHandle: PropTypes.func,
  onValidate: PropTypes.func,
  requestData: PropTypes.object,
  isLoading: PropTypes.bool,
  type: PropTypes.string,
  isFormValid: PropTypes.bool
};

export default ModalConfirm;



// WEBPACK FOOTER //
// ./src/components/ModalConfirm/index.js